import React, { Fragment, useState } from 'react';
import Services from '../../api/services';
import {Link, useParams} from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/business/Footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icons/icon_check_3.svg';
import Bg from '../../images/services/cybersecurity-oplossingen_image.webp';

const ServiceSinglePage = () => {
    const { slug } = useParams();
    const ServiceDetails = Services.find(item => item.slug === slug);
    const [isOpen, setOpen] = useState(false);
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <Fragment>
            <Header />
            <main className="page_content service-single-page">
                <PageTitle pageTitle={ServiceDetails.title} bgImage={Bg} />
                <section className="service_details_section section_space bg-light">
                    <div className="container">
                        <h2 className="details_item_title">{ServiceDetails.title}</h2>
                        <p>{ServiceDetails.introText}</p>

                        {/* Service Details */}
                        {ServiceDetails.details.map((detail, index) => (
                            <p key={index}>{detail.text}</p>
                        ))}

                        {/* How Does It Work Section */}
                        <h3 className="details_item_info_title">{ServiceDetails.howDoesItWork}</h3>
                        <div className="row mb-4">
                            {ServiceDetails.features.map((feature, colIndex) => (
                                <div className="col-lg-6" key={colIndex}>
                                    <ul className="icon_list unordered_list_block">
                                        {feature.items.map((item, itemIndex) => (
                                            <li key={itemIndex}>
                                                <span className="icon_list_icon">
                                                    <img src={icon} alt="Check SVG Icon" />
                                                </span>
                                                <span className="icon_list_text">{item}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>

                        {/* Image Gallery */}
                        <div className="row">
                            {ServiceDetails.imageGallery.map((image, imgIndex) => (
                                <div className="col-lg-4 col-md-6 col-sm-6" key={imgIndex}>
                                    <div className="details_item_image m-0">
                                        <img src={image.src} alt={image.alt} width={image.width} height={image.height} />
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Conditional Call to Action Button */}
                        {ServiceDetails.callToAction && (
                            <div style={{ paddingTop: "50px"}}>

                                <Link onClick={ClickHandler} to={ServiceDetails.callToAction.formLink} className="btn btn-primary">
                                    <span className="btn_label" data-text={ServiceDetails.callToAction.text}>{ServiceDetails.callToAction.text}</span>
                                    <span className="btn_icon">
                                        <i className="fa-solid fa-arrow-up-right"></i>
                                 </span>
                                </Link>
                            </div>
                        )}
                    </div>
                </section>
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="7e90gBu4pas" onClose={() => setOpen(false)} />
        </Fragment>
    );
};

export default ServiceSinglePage;
